import _isEmpty from 'lodash/isEmpty';
import { create } from 'zustand';
import { getAllParamsUpTo, globalParams, normalizeQuery, } from '../utils';
export const useNavigationStore = create()((set, get) => ({
    isInit: false,
    queries: {},
    currStep: !_isEmpty(get()?.queries)
        ? Object.keys?.(get()?.queries).length
        : 0,
    setCurrentStep: (step) => set(() => ({ currStep: step })),
    setIsInit: (flag) => set(() => ({ isInit: flag })),
    goToStep: (step) => set(() => ({ currStep: step })),
    advanceStep: () => {
        set((state) => ({
            currStep: state.currStep + 1,
        }));
    },
    getPreviousStep: () => {
        const prevStep = get().currStep - 1;
        const allStepsTilNow = [
            ...Object.keys(getAllParamsUpTo(prevStep)),
            ...Object.keys(globalParams),
        ];
        const prevQuery = get().queries;
        const queriesOnPrevStep = allStepsTilNow.reduce((acc, key) => {
            if (prevQuery[key]) {
                Object.assign(acc, { [key]: prevQuery[key] });
            }
            return acc;
        }, {});
        set(() => ({ queries: queriesOnPrevStep }));
        set((state) => ({ currStep: state.currStep - 1 }));
    },
    setQueries: (query) => {
        set((state) => ({
            queries: normalizeQuery({ ...state.queries, ...query }),
        }));
    },
    removeQueries: () => set(() => ({ queries: {}, currStep: 0 })),
}));
